import styled from 'styled-components'

import { Image as ImageBase } from '@application/Interfaces/Atoms/Image'
import { Tilt as TiltBase } from '@application/Interfaces/Atoms/Tilt'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const Tilt = styled(TiltBase)`
    width: 100%;
    height: 100%;
`

export const Wrapper = styled.div<{ $columnCount: number }>`
    display: flex;
    justify-content: space-between;
    padding: 16px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: ${(props) => (props.$columnCount < 2 ? '16px' : '40px')};
    }
`

export const Section = styled.div<{ $imageSection?: boolean }>`
    width: 250px;
    margin-right: 16px;
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;

    &:last-child {
        margin-right: 0;
    }

    ${(props) =>
        props.$imageSection &&
        `
        justify-content: end;
        align-items: center;
    `}
`

export const SectionTitle = styled.div`
    color: ${(props) => props.theme.color.g400};
    ${(props) => props.theme.typo.bodyXS}
    ${(props) => props.theme.fontWeight.regular};
    margin-bottom: 24px;
    min-height: 18px;
    text-transform: uppercase;
`

export const Link = styled(LinkBase)`
    text-decoration: none;
`

export const ImageTitle = styled.div`
    color: ${(props) => props.theme.color.p500};
    ${(props) => props.theme.typo.displayXS}
    ${(props) => props.theme.fontWeight.medium};
    margin-bottom: 4px;
`

export const ImageDescription = styled.div`
    color: ${(props) => props.theme.color.g400};
    ${(props) => props.theme.typo.bodyS}
    ${(props) => props.theme.fontWeight.regular};
    margin-bottom: 4px;
`

export const TopImageWrapper = styled.div<{ $hasContent?: boolean }>`
    ${(props) =>
        props.$hasContent &&
        `
        background-color: ${props.theme.color.p100};
        border: 1px solid ${props.theme.color.p200};
        border-radius: 18px;
        padding:24px;
    `}
`

export const TopImage = styled(ImageBase)`
    max-width: 169px;
    margin-bottom: 8px;
`

export const BlueLink = styled(LinkBase)<{ $isViewAllLink?: boolean }>`
    color: ${(props) => props.theme.color.p500};
    text-decoration: none;
    ${(props) => props.theme.typo.displayXXS}
    ${(props) => props.theme.fontWeight[props.$isViewAllLink ? 'medium' : 'regular']}
    
    ${(props) =>
        props.$isViewAllLink &&
        `
        padding: 0 8px;
        `}

    svg {
        margin-left: 5px;
    }

    &:hover,
    &:focus {
        color: ${(props) => props.theme.color.p600};

        svg {
            path {
                stroke: ${(props) => props.theme.color.p600};
            }
        }
    }
`

export const BackgroundImageContent = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 30px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    top: 100%;
    transition: 0.3s ease-in-out;
    z-index: 1;
`

export const BackgroundImageTitle = styled.h3`
    color: ${(props) => props.theme.color.white};
    ${(props) => props.theme.typo.displayM}
    ${(props) => props.theme.fontWeight.bold}
    position: absolute;
    bottom: 20px;
    left: 20px;
    padding-right: 20px;
    opacity: 1;
    transition: opacity 0.2s ease-out;
`

export const BackgroundImageWrapper = styled.div`
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    height: 100%;
    width: 100%;

    &:after {
        content: ' ';
        width: 100%;
        height: 100%;
        position: absolute;
        background: none;
        transition: 0.3s ease-in-out;
        top: 0px;
    }

    &:hover,
    &:focus {
        &:after {
            background: rgba(0, 0, 0, 0.7);
        }

        ${BackgroundImageTitle} {
            opacity: 0;
        }

        ${BackgroundImageContent} {
            top: 0px;
        }
    }
`

export const BackgroundImageDescription = styled.div`
    color: ${(props) => props.theme.color.white};
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.regular}
`

export const BackgroundImageLink = styled(LinkBase)`
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.medium}
    color: ${(props) => props.theme.color.white};
    margin-top: 10px;
    display: block;
    text-transform: uppercase;
    text-decoration: none;

    svg {
        margin-left: 5px;
    }

    &:hover,
    &:focus {
        color: ${(props) => props.theme.color.a500};

        svg {
            path {
                stroke: ${(props) => props.theme.color.a500};
            }
        }
    }
`

export const Footer = styled.div`
    background-color: ${(props) => props.theme.color.p100};
    border-top: 1px solid ${(props) => props.theme.color.p200};
    padding: 24px;
    display: flex;
`
export const FooterImage = styled(ImageBase)`
    max-width: 74px;
    margin-right: 16px;
`

export const FooterContent = styled.div``

export const FooterDescription = styled.p`
    color: ${(props) => props.theme.color.g500};
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.regular}
    margin-bottom: 4px;
`
